<template>
    <b-autocomplete
      rounded
      field="name"
      v-model="symbol"
      v-bind:data="fundData"
      placeholder="Search for a fund symbol"
      icon="search"
      icon-pack="fas"
      clearable
      v-on:select="option => (selectFund(option))"
      @input="loadResults"
      check-infinite-scroll
    >
      <template slot-scope="props">
        <div class="media">
          <div class="media-left">
            <b-icon pack="fas" icon="layer-group"
          </div>
          <div class="media-content">
            <strong>{{ props.option.ticker.symbol }}</strong>
            <br>
            <small>{{ props.option.ticker.full_name }}</small>
            <br>
            <p class="is-size-7 is-italic">Holdings as reported to the Securities and Exchange Commission on {{props.option.ticker.filing_date}}</p>
          </div>
      </div>
    </template>
    <template slot="empty">No results found</template>
  </b-autocomplete>
</template>

<script>
export default {
  data() {
    return {
      fundData: [],
      loading: false,
      symbol: '',
      abortControllers: [],
    };
  },
  components: {},
  props: {
    callback: Function,
  },
  computed: {
  },
  methods: {
    selectFund: function(option) {
      this.callback.call(this, option);
    },
    async loadResults() {
      this.abortControllers.forEach(controller => controller.abort());
      const abortController = new AbortController();
      this.abortControllers.push(abortController);
      this.loading = true;
      try {
        const data = await fetch(`/api/v1/explore/funds/?search=${this.symbol}`, { signal: abortController.signal });
        const jsonData = await data.json();
        this.fundData = jsonData.funds;
      } catch (e) {
        if (e.name === 'AbortError') {
          console.log('aborted');
        } else {
          console.log(e);
        }
      }
      this.loading = false;
    },
  },
};
</script>
